// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FormCheckbox_wrapper","disabled":"FormCheckbox_disabled"};